export default "__VITE_ASSET__CQTpx2jE__"